import camelcaseKeys from 'camelcase-keys';
import { buildEmptyColumn } from './mutations';

export const getters = {
  getGroupByAttributeKey: $state => $state.groupByAttributeKey,

  getUIFlags: $state => $state.uiFlags,

  getColumn: $state => columnValue => {
    const column = $state.columns[columnValue] || buildEmptyColumn();
    return {
      ...column,
      contacts: column.contactIds.map(id =>
        camelcaseKeys(column.contactsById[id], {
          deep: true,
          stopPaths: ['custom_attributes'],
        })
      ),
    };
  },
};
